export default "__VITE_ASSET__CkX8f0De__"